<template>
  <b-modal
    id="modal-appointment"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
  <!-- @hide="resetModal" -->
    <template #modal-header="{ close }">
      <h3 class="m-0">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-clock" />預約時間
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>
    <b-alert
      variant="primary"
      show
    >
      <div class="alert-body">
        <span>請最少預留3-4個工作天進行預約。</span>
      </div>
    </b-alert>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_booking_time"
              >
                <b-form-group
                  label="預約時間："
                  label-for="booking_time"
                  label-cols-md="3"
                  class="required"
                >
                  <flat-pickr
                    v-model="newAppointmentData.booking_time"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d H:i',
                      dateFormat: 'Y-m-d H:i',
                    }"
                    placeholder="輸入YYYY-MM-DD hh:mm"
                  />

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_booking_title"
              >
                <b-form-group
                  label="預約主題："
                  label-for="booking_title"
                  label-cols-md="3"
                  class="required"
                >
                  <b-form-input
                    id="booking_title"
                    v-model="newAppointmentData.booking_title"
                    placeholder="輸入預約主題"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- content -->
            <b-col cols="12" md="12">
              <validation-provider
                #default="validationContext"
                name="此欄"
                rules="required"
                vid="v_content"
              >
                <b-form-group
                  label="預約內容："
                  label-for="content"
                  label-cols-md="3"
                  class="required"
                >
                  <quill-editor
                    id="content"
                    v-model="newAppointmentData.content"
                    :options="editorOption"
                  />

                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="12" v-if="ability.can('appointment_status', 'order_detail')">
                <b-form-group
                  label="預約狀態："
                  label-for="project_booking_status_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="project_booking_status_id"
                    v-model="newAppointmentData.project_booking_status_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="bookingStatusOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="預約狀態"
                  >
                  </v-select>
                </b-form-group>
            </b-col>

            <!-- <b-col cols="12">
              <div class="d-flex mt-2 mb-1">
                <div class="d-inline-flex align-items-center">
                  <b-form-checkbox
                    v-model="newAppointmentData.toPDF"
                    id="exempt"
                    class="mr-0"
                    inline
                  />
                  <label class="mb-0" for="exempt" style="white-space: nowrap"
                    >製造成同一PDF</label>
                </div>
              </div>
            </b-col> -->
          </b-row>
          <div class="d-flex mt-2 justify-content-end">
           
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="mr-1"
            >
              <font-awesome-icon
                class="mr-25"
                icon="fa-solid fa-circle-check"
              />
              提交
            </b-button> 
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              @click="hide"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
  BFormCheckbox,
  BAlert
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import uploadFile from "@/layouts/components/file/uploadFile.vue";
import ability from "@/libs/acl/ability";
import { isHtmlContent, plainTextToHtml, htmlToPlainText } from "@/libs/rich-text";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    BFormCheckbox,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
    BAlert,
    quillEditor
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    bookingStatusOptions:{},
    appointmentData:{},
    project_id:{},
    is_customer:{},
  },
  data() {
    return {
      required,
      ability,
      editorOption: {
        placeholder: "輸入預約內容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }],
            ["clean"],
          ],
        },
      },
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-appointment");
    },
    resetModal(){
      this.newAppointmentData = {id:0}
    },
    onSubmit() {
      // Quill 在「空白」時仍會產生 <p><br></p>，required 規則擋不住，
      // 這裡自行檢查去掉標籤後是否真的有內容。
      if (!htmlToPlainText(this.newAppointmentData.content).trim()) {
        this.$swal({
          text: "預約內容必需填寫。",
          icon: "error",
          confirmButtonText: "確定",
          customClass: { confirmButton: "btn btn-primary" },
          buttonsStyling: false,
        });
        return;
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.newAppointmentData.project_id = this.newAppointmentData.project_id ? this.newAppointmentData.project_id : this.project_id
          store
            .dispatch("order/editProjectBooking",this.newAppointmentData )
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide()
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newAppointmentData = ref({ id: 0 });

    const resetAppointmentData = () => {
      newAppointmentData = JSON.parse(JSON.stringify({ id: 0 }));
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetAppointmentData
    );

    watch(
      () => props.appointmentData,
      (newVal) => {
        const data = { ...newVal };
        // 舊記錄是純文字（用 \n 換行），載入編輯器前先轉成 HTML，
        // 否則換行會被吃掉。
        if (data.content && !isHtmlContent(data.content)) {
          data.content = plainTextToHtml(data.content);
        }
        newAppointmentData.value = data;
      }
    );

    return {
      loading,
      newAppointmentData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#modal-appointment {
  .ql-container {
    height: 180px;
  }
  .ql-editor {
    min-height: 180px;
  }
}
// #modal-message-message {
//   .full_input label {
//     width: calc(13% - 3px);
//   }
// }
</style>
